import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import BootstrapVue from 'bootstrap-vue'
import './registerServiceWorker'
import { syncForOffline, checkCookie, checkPermission } from './sync/sync'
import axios from 'axios'
import vSelect from 'vue-select'
import {
  i18n
} from './plugins/i18n'
import mixins from './mixins/index'
import SequentialEntrance from 'vue-sequential-entrance'
import 'vue-sequential-entrance/vue-sequential-entrance.css'
// import VeeValidate from 'vee-validate'
import Notifications from 'vue-notification'
import VueSweetalert2 from 'vue-sweetalert2'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import CKEditor from '@ckeditor/ckeditor5-vue'
import VueCharts from 'vue-chartjs'

import localforage from 'localforage'
export const EventBus = new Vue()
localforage.config({
  driver: localforage.INDEXEDDB, // Force WebSQL; same as using setDriver()
  name: 'produs-retea',
  version: 1.0,
  size: 4980736, // Size of database, in bytes. WebSQL-only for now.
  storeName: 'produs_retea', // Should be alphanumeric, with underscores.
  description: 'some description'
})

window._ = require('lodash')
window.$ = window.jQuery = require('jquery')
require('./filters/index')

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT
axios.defaults.headers.common['X-localization'] = 'ro'
// axios.defaults.headers.get['Content-Type'] = 'text/plain'
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
// axios.defaults.headers.common['Access-Control-Allow-Headers'] = '*'
axios.defaults.responseType = 'json'
const token = localStorage.getItem('user-token') || null
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

// Vue.use(VeeValidate)
Vue.use(SequentialEntrance)
Vue.component('v-select', vSelect)
Vue.use(BootstrapVue)
Vue.use(Notifications)
Vue.use(VueSweetalert2)
Vue.use(CKEditor)
Vue.use(VueCharts)
Vue.use(require('vue-moment'))
Vue.use(require('vue-shortkey'))
Vue.use(Viewer)
Vue.config.productionTip = false
if (!checkCookie('synced')) {
  if (store.getters.isAuthenticated) {
    store.dispatch('startDataSync')
    syncForOffline()
  }
}
if (!checkCookie('checked_perm')) {
  checkPermission()
}
Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

// Vue.directive('click-outside', {
//   priority: 700,
//   bind: function (el, binding, vNode) {
//     if (typeof binding.value !== 'function') {
//       const compName = vNode.context.name
//       let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
//       if (compName) {
//         warn += `Found in component '${compName}'`
//       }
//       console.warn(warn)
//     }
//     const bubble = binding.modifiers.bubble
//     const handler = (e) => {
//       if (bubble || (!el.contains(e.target) && el !== e.target)) {
//         binding.value(e)
//       }
//     }
//     el.__vueClickOutside__ = handler
//     document.addEventListener('click', handler)
//   },
//
//   unbind: function (el, binding) {
//     document.removeEventListener('click', el.__vueClickOutside__)
//     el.__vueClickOutside__ = null
//   }
// })

window.document.body.onscroll = function () {
  store.dispatch('adjustLoadingContainer')
}
// Vue.mixin({
//   created: function () {
//     var myOption = this.$options.myOption
//     if (myOption) {
//       console.log(myOption)
//     }
//   }
// })
new Vue({
  router,
  store,
  i18n,
  mixins: [mixins],
  render: h => h(App)
}).$mount('#app')
